module.exports = __webpack_public_path__ + "dist/img/how-it-works-drivetrain.6a829fdd.svg";